import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { actions } from '../../../state/actions';
import { connect } from 'react-redux';
import { Api } from './../../../api/api';
import { config } from './../../../api/config';
import { format } from 'date-fns';

import swal from 'sweetalert';

import {
  WithSpinner,
  InputWithTextInline,
  Button,
  TableAdmin,
  TableRow,
  TableCell,
} from '../../../components';

const VmiRequests = ({ loading }) => {
  const [notValid, setNotValid] = useState(false);
  const [companyCode, setCompanyCode] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [list, setList] = useState([]);

  const tableHeader = [
    'Asmens/įmonės kodas',
    'Bendra eksporto suma (be PVM)',
    'Eksporto duomenų atsakymo data (iš VMI)',
    'Bendra importo suma (be PVM)',
    'Importo duomenų atsakymo data (iš VMI)',
    'Užklausos siuntimo data ir laikas',
    'Atsakymo gavimo data ir laikas',
    'Užklausą teikęs darbuotojas',
  ];

  const renewList = () => {
    setIsloading(true);

    fetch(Api.API_BASE_URL + config.API_ENDPOINTS.VmiAdditionalChecksList, {
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => {
        if (res.ok === true) {
          console.log(res);
          res.json().then((r) => {
            setList(r);
          });
        } else {
          swal({
            title: 'Klaida',
            icon: 'error',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn swal-ok-btn',
                closeModal: true,
              },
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsloading(false);
      });

    setNotValid(false);
  };

  const check = () => {
    setNotValid(true);
    if (companyCode.length === 9 || companyCode.length === 11) {
      setIsloading(true);

      fetch(
        Api.API_BASE_URL +
          config.API_ENDPOINTS.VmiAdditionalChecksSave(companyCode),
        {
          method: 'POST',
          credentials: 'include',
        }
      )
        .then((res) => {
          if (res.ok === true) {
            renewList();
            swal({
              title: 'Užklausa į VMI sėkmingai nusiųsta',
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            });
          } else {
            swal({
              title: 'Užklausa į VMI nesėkminga',
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          }
        })
        .catch((err) => {
          console.log('catch block');
          console.log(err);
        })
        .finally(() => {
          setIsloading(false);
        });

      setNotValid(false);
    }
  };
  useEffect(() => {
    renewList();
  }, []);
  return (
    <WithSpinner loading={isLoading}>
      <div style={{ margin: '20px auto 50px 34px' }}>
        <Button type="darkBlue" style={{ marginRight: '10px' }}>
          <Link
            // to="/backoffice/main"
            style={{
              color: '#fff',
              textDecoration: 'none',
            }}
          >
            VMI užklausos
          </Link>
        </Button>

        <Button type="lightBlue">
          <Link to="/backoffice/additionalRequests">JAR užklausos</Link>
        </Button>
      </div>
      <div style={{ width: '96%', marginLeft: '2%', marginTop: '2rem' }}>
        <h2>VMI užklausos</h2>

        <Button type="standart">
          <Link
            to="/backoffice/main"
            style={{
              color: '#fff',
              textDecoration: 'none',
            }}
          >
            Atgal
          </Link>
        </Button>

        <div
          className="col-lg-6 col-sm-12"
          style={{
            display: 'flex',
            justifyContext: 'spacebetween',
            width: '400px',
            marginTop: '30px',
            padding: 0,
          }}
        >
          <div style={{ width: '151%' }}>
            <InputWithTextInline
              name={'LastName'}
              type="string"
              onChange={(e) => setCompanyCode(e.target.value)}
              value={companyCode}
              placeholder={'Įmonės/asmens kodas'}
              disabled={false}
            />
            {notValid &&
              (companyCode.length !== 9 || companyCode.length !== 11) && (
                <p
                  className="errorsBlockText error1"
                  style={{ color: 'var(--pinkDark)', width: '120%' }}
                >
                  * įmonės kodas turi būti sudarytas iš 9 skaitmenų, o asmens
                  kodas - iš 11 skaitmenų
                </p>
              )}
          </div>
          <button
            type="standart"
            className="vaiisisloginbtn"
            style={{
              width: '310px',
              marginTop: '35px',
              height: '40px',
              marginLeft: '10px',
            }}
            onClick={() => check()}
          >
            Tikrinti VMI
          </button>
        </div>
        <div style={{ marginTop: '40px' }}>
          <h4>Tikrintos VMI įmonės/asmenys</h4>
          <TableAdmin header={tableHeader} isEmpty={false}>
            {list.map(
              ({
                Id,
                Created,
                Finished,
                Code,
                VmiExportDate,
                VmiExportSum,
                VmiImportDate,
                VmiImportSum,
                UserPersonalName,
              }) => (
                <TableRow key={Id}>
                  <TableCell>{Code}</TableCell>
                  <TableCell>{VmiExportSum}</TableCell>
                  <TableCell>
                    {VmiExportDate !== null &&
                      format(new Date(VmiExportDate), 'yyyy-MM-dd')}
                  </TableCell>
                  <TableCell>{VmiImportSum}</TableCell>
                  <TableCell>
                    {VmiImportDate !== null &&
                      format(new Date(VmiImportDate), 'yyyy-MM-dd')}
                  </TableCell>
                  <TableCell>
                    {Created !== null &&
                      format(new Date(Created), 'yyyy-MM-dd HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    {Finished !== null &&
                      format(new Date(Finished), 'yyyy-MM-dd HH:mm:ss')}
                  </TableCell>
                  <TableCell>{UserPersonalName}</TableCell>
                </TableRow>
              )
            )}
          </TableAdmin>
        </div>
        {/* </div> */}
      </div>
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboardState.isOnSync,
});

export default connect(mapStateToProps)(VmiRequests);
